import { BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { MessageBoxService } from './message-box.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./message-box.service";
export class EpayService {
    constructor(_http, _msgBox) {
        //this.epaySource.next(this.epaySettings);
        this._http = _http;
        this._msgBox = _msgBox;
        this.epaySettings = [
            { index: 1, name: "merchantnumber", value: "8033377", type: "input" },
            { index: 2, name: "currency", value: "DKK", type: "input" },
            { index: 3, name: "instantcapture", value: "1", type: "input" },
            { index: 4, name: "windowstate", value: "3", type: "input" },
            { index: 5, name: "accepturl", value: "http://dev-tilmelding.ollerup.dk/%LANG%/public/payment/success", type: "input" },
            { index: 6, name: "cancelurl", value: "http://dev-tilmelding.ollerup.dk/%LANG%/public/payment/cancel", type: "input" },
            { index: 7, name: "callbackurl", value: "http://dev-webapi.ollerup.dk/order/epay", type: "input" },
        ];
        //SUBSCRIBTION EPAY PARAMETRE
        this.epaySource = new BehaviorSubject([]);
        this.epay$ = this.epaySource.asObservable();
        this._http.get('admin/settings/epay').subscribe(result => {
            this.epaySource.next(result);
        }, (error) => {
            console.log(error.message);
        });
    }
    saveEpaySettings(settings) {
        this._http.patch('admin/settings/epay/edit', settings).subscribe((result) => {
            this._msgBox.createMessageboxSuccess(result.message);
        }, (error) => {
            this._msgBox.createMessageboxError(error.message);
        });
    }
}
EpayService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function EpayService_Factory() { return new EpayService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.MessageBoxService)); }, token: EpayService, providedIn: "root" });
